export const L10N = {
  LABEL_REDIRECTING: { id: 'core.label.redirecting', defaultMessage: 'Redirecting…' },
  LABEL_SECURE_PAGE: { id: 'core.label.secure_page' },
};
